import { render } from "./TanaoroshiSaiPage.vue?vue&type=template&id=ca71266c"
import script from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"

import "./TanaoroshiSaiPage.vue?vue&type=style&index=0&id=ca71266c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__